import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import * as R from 'ramda'
import PercentageSliderNumericCombo from './formElements/PercentageSliderNumericCombo'
import { getPrintPreview } from './utils'

@observer
export default class Percentage extends Component {

	constructor(props){
		super(props)
		//this component handles the state of the percentage form control internally for performance reasons
		this.state = {
	      totals: {},
		  totalsInitialized: false
	    };
		this.componentDidMount = this.componentDidMount.bind(this)
		this.updateTotals = this.updateTotals.bind(this)
		this.getTotals = this.getTotals.bind(this)
		this.getSummedTotal = this.getSummedTotal.bind(this)
        this.init()
	}

    init = () => {
        const { question , store } = this.props
        const { form_data } = store
        
        const { max } = question.settings.frontend
        this.questionMax = max || 100

        const [inheritQuestion, inheritOption] = R.pathOr('', ['settings', 'frontend', 'inheritMax'])(question).split('|')

        if (inheritQuestion) {
            const inheritFormData = form_data.has(inheritQuestion)
                ? form_data.get(inheritQuestion)
                : {}
            const { questionType, data } = inheritFormData
            console.log(`inheritFormData ${JSON.stringify(inheritFormData, null, 4)}`)

            if (questionType === 'PC') {
                this.questionMax = R.pathOr(this.questionMax, [inheritOption])(data)
            } else if (questionType === 'I') {
                this.questionMax = data.value
            }
        }
        question.questionMax = this.questionMax
    }

	componentDidMount(props){
		const {question, store} = this.props
		const {form_data} = store
		if(form_data.has(question.id)){
			this.setState({
		        totals: form_data.get(question.id).data,
				totalsInitialized: true
		    });
		} else {
			const totals = {}
			question.optionSet.options.forEach(option => {
				totals[option.id] = 0
			})
			this.setState({
		        totals: totals,
				totalsInitialized: true
		    });
		}
	}

	updateTotals(valueObj){
		var existingObj = this.state.totals
		var merged = Object.assign({}, existingObj, valueObj);
		this.setState({
	        totals: merged
	    });
		//console.log(merged)
	}

	getTotals(){
		return this.state.totals
	}

	getSummedTotal() {
		if(typeof this.state.totals === "object"){
			var total = 0
			for(let i in this.state.totals){
				total += parseInt(this.state.totals[i])
			}
			return total
		}
    }
    
    render() {
		const {question, store} = this.props
        console.log('filter percentage')
		//if statement below because changing state in componentDidMount() will force a second render
		//see https://facebook.github.io/react/docs/react-component.html#componentwillreceiveprops

		//console.log(this.state.totals)
        const { format } = question.settings.frontend
		const {form_data} = store
		const set = question.optionSet
		const options = set.options.filter(o => o.willDisplay !== false)
		const questionType = question.questionTypeCode
		const questionId = question.id
		//const total = form_data.has(question.id) ? form_data.get(question.id).total : 0
		const sliderNumboxCombos = options.map((option) =>
			<PercentageSliderNumericCombo
				getTotals={this.getTotals.bind(this)}
				getSummedTotal={this.getSummedTotal.bind(this)}
				updateTotals={this.updateTotals.bind(this)}
				key={option.id}
				option={option}
				question={question}
				store={store}
                questionMax={this.questionMax}
                format={format}
			/>
		);
    	return (
    		<div className="slidercontainer">
                {getPrintPreview(question, store)}
                <div className="options">{sliderNumboxCombos}</div>
				<div className="total">Total: {this.getSummedTotal()} / {this.questionMax}</div>
    		</div>
    	)
    }
}
